import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import DisabilityContainer from './container/DisabilityContainer';

function PwdSettingsTabContainer({ match, pathName, permissions }) {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row border-bottom-row">
          <ul className="nav nav-tabs sub-tab-borongan">
            {Acl(permissions, ['VIEW PWD DISABILITY SETTINGS']) && (
              <li className="nav-item">
                <Link
                  to="/social-ameliorations/settings/pwd"
                  className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf(
                    '/social-ameliorations/settings/pwd/disability'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Type of Disability
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/disability`} />}
        />
        {Acl(permissions, ['VIEW PWD DISABILITY SETTINGS']) && (
          <Route
            path={`${match.path}/disability`}
            component={DisabilityContainer}
          />
        )}
      </Switch>
    </React.Fragment>
  );
}

PwdSettingsTabContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(PwdSettingsTabContainer);
